import { OffTrackCtrl } from './review-off-track.controller';

export const OffTrack = {
  controller: OffTrackCtrl,
  bindings: {
    prevStep: '&',
  },
  template: require('./review-off-track.html'),
};
